import { Auth0Provider } from "@auth0/auth0-react";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useOrgIdViaEmail } from "~/hooks/query";
import useAuthStore from "~/store/auth";

export function AuthProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const userInfo = useAuthStore((state) => state.userInfo);
  const { data: organization } = useOrgIdViaEmail(userInfo.email);
  const organizationParams = organization ? { organization } : {};
  return (
    <Auth0Provider
      audience={import.meta.env.VITE_AUTH_AUDIENCE}
      domain={import.meta.env.VITE_AUTH_DOMAIN}
      clientId={import.meta.env.VITE_AUTH_CLIENT_ID}
      redirectUri={window.location.origin}
      onRedirectCallback={(appState) => {
        if (appState?.returnTo) {
          navigate(appState.returnTo);
        }
      }}
      {...organizationParams}
    >
      {children}
    </Auth0Provider>
  );
}
